const filters = [
  {
    id: 'message-filter-note',
    name: 'note',
    text: 'dashboard_notes',
    activeIcon: 'icon-note-primary-dark',
    icon: 'icon-note-grey'
  },
  {
    id: 'message-filter-file-operator',
    name: 'fileOperator',
    text: 'dashboard_files-sent',
    activeIcon: 'icon-upload-primary-dark',
    icon: 'icon-upload-grey'
  },
  {
    id: 'message-filter-file-user',
    name: 'fileUser',
    text: 'dashboard_files-received',
    activeIcon: 'icon-download-primary-dark',
    icon: 'icon-download-grey'
  },
  {
    id: 'message-filter-operator',
    name: 'operator',
    text: 'dashboard_operator-messages',
    activeIcon: 'icon-message-square-primary-dark',
    icon: 'icon-message-square-grey'
  },
  {
    id: 'message-filter-automatic',
    name: 'automatic',
    text: 'dashboard_automation-messages',
    activeIcon: 'icon-automation-message-square-primary-dark',
    icon: 'icon-automation-message-square-grey'
  },
  {
    id: 'message-filter-user',
    name: 'user',
    text: 'dashboard_user-messages',
    activeIcon: 'icon-user-primary-dark',
    icon: 'icon-user-grey'
  },
  {
    id: 'message-filter-audio',
    name: 'audio',
    text: 'dashboard_audio-notes',
    activeIcon: 'icon-mic-primary-dark',
    icon: 'icon-mic-grey'
  },
  {
    id: 'message-filter-location',
    name: 'customer_location',
    text: 'dashboard_locations',
    activeIcon: 'icon-location-primary-dark',
    icon: 'icon-location-grey'
  },
  {
    id: 'message-filter-campaign',
    name: 'campaign',
    text: 'dashboard_campaigns',
    activeIcon: 'icon-campaign-primary-dark',
    icon: 'icon-campaign-grey'
  },
  {
    id: 'message-filter-outbound',
    name: 'outbound',
    text: 'dashboard_outbound-messages',
    activeIcon: 'icon-outbound-slim-primary-dark',
    icon: 'icon-outbound-slim-grey'
  },
]

export default filters
